import "./Appointments.css";
import React, { Fragment, useEffect, useState } from "react";

import {
  ScheduleComponent,
  Day,
  Week,
  WorkWeek,
  Month,
  Agenda,
  Inject,
} from "@syncfusion/ej2-react-schedule";

// Controllers Start
import GetAppointments from "../../controllers/appointments/GetAppointments";
// Controllers End

// MUI Start
import Modal from "@mui/material/Modal";
import Autocomplete from "@mui/material/Autocomplete";
import { Avatar, Card, MenuItem, TextField, Typography } from "@mui/material";
// MUI End

import { stringAvatar } from "../../helpers/stringAvatar";
import GetSingleAppointmentData from "../../controllers/appointments/GetSingleAppointmentData";
import UpdateSingleAppointment from "../../controllers/appointments/UpdateSingleAppointment";
import moment from "moment";
import GetTotalAgents from "../../controllers/agents/GetTotalAgents";
import GetTotalLeads from "../../controllers/leads/GetTotalLeads";
import GetSingleLeadData from "../../controllers/leads/GetSingleLeadData";
import GetSingleDeal from "../../controllers/Enquiries/GetSingleDeal";
import GetSingleAgentData from "../../controllers/agents/GetSingleAgentData";
import UpdateAppointmentStatus from "../../controllers/appointments/UpdateAppointmentStatus";
import { useCallback } from "react";
import AddUpdateAppointmentModal from "../../components/Common/AddUpdateAppointmentModal/AddUpdateAppointmentModal";

const Appointments = () => {
  const [Refresh, setRefresh] = useState(true);
  const [AppointmentId, setAppointmentId] = useState("");
  const [OpenAddUpdateModal, setOpenAddUpdateModal] = useState(false);
  const [Appointments, setAppointments] = useState([]);

  const handleRefresh = () => {
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      let isMounted = true; // note mutable flag

      if (isMounted) {
        const AppointmentsData = await GetAppointments();
        setAppointments(AppointmentsData);
      }

      return () => {
        isMounted = false;
      }; // cleanup toggles value, if unmounted
    }
    fetchData();
  }, [Refresh]);

  const AppointmentArray = [];
  Appointments.map((appointment) => {
    return AppointmentArray.push({
      Id: appointment.id,
      Subject: appointment.title,
      StartTime: new Date(appointment.startDate.toDate()),
      EndTime: new Date(appointment.endDate.toDate()),
      Location: appointment.isDone
        ? "Appointment is completed"
        : "Appointment is not yet completed",
    });
  });
  const onPopupOpen = (args) => {
    args.cancel = true;
  };
  return (
    <Fragment>
      <div className="global-body-container appointments-listing">
        <div className="appointment-header">
          <h3 className="custom-heading">Appointments</h3>
          <button
            onClick={() => {
              setAppointmentId("");
              setOpenAddUpdateModal(true);
            }}
            className="add-appointment-button"
          >
            <svg
              className="add-appointment-btn-svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 17V7"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M7 12H17"
                stroke="white"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
            Add Appointment
          </button>
        </div>
        <ScheduleComponent
          height={700}
          style={{ cursor: "pointer" }}
          currentView="WorkWeek"
          eventSettings={{
            dataSource: AppointmentArray,
          }}
          eventClick={(e) => {
            setOpenAddUpdateModal(true);
            setAppointmentId(e.event.Id);
          }}
          popupOpen={(e) => {
            onPopupOpen(e);
          }}
          cellClick={false}
        >
          <Inject services={[Day, Week, WorkWeek, Month, Agenda]} />
        </ScheduleComponent>
      </div>
      <AddUpdateAppointmentModal
        AppointmentId={AppointmentId}
        setAppointmentId={setAppointmentId}
        handleRefresh={handleRefresh}
        OpenAddUpdateModal={OpenAddUpdateModal}
        setOpenAddUpdateModal={setOpenAddUpdateModal}
      />
    </Fragment>
  );
};

export default Appointments;
